import ClassView from './class'

const ClassReportingView = ClassView.extend({
    reporting: true,
})

export default ClassReportingView
